<template>
  <component :is="el" :label="label" :required="required">

    <span v-if="noForm">{{label}}&nbsp;</span>

    <el-select
      v-model="formData"
      :disabled="disabled"
      :placeholder="placeholder"
      value-key="value"
      :size="size"
      @change="updated">

      <el-option-group
        v-for="group in groups"
        :key="group.label"
        :label="group.label">
<!--
        <span :style="'float: left; width: 100%; background-color: ' + getCatColour(group.label) + ';'">{{ group.label }}
          <span style="float: right; color: #8492a6; margin-right: 5px; font-size: 12px" :class="getCatIcon(group.label)" />
        </span>
-->
        <el-option
          v-for="item in group.options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
          <span :style="'float: left; width: 100%; background-color: ' + getCatColour(item.category) + ';'">{{ item.label }}
            <span style="float: right; color: #8492a6; margin-right: 5px; font-size: 12px" :class="getCatIcon(item.category)" />
          </span>
        </el-option>

      </el-option-group>

    </el-select>
  </component>
</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'

export default {
  name: 'select-organisation',

  mixins: [ArrayMixins],

  props: {

    label: {
      type: String,
      default: 'Organisation'
    },

    value: {
//      type: String,
      required: true
    },

    type: {
      type: [Array, String],
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Select Organisation'
    },

    helpText: {
      type: String,
      default: null
    },

    sharerLimits: {
      type: Array,
      default: null
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    getCatMetaData (cat, type) {

      switch (cat) {

        case 'Backhaul':
          return (type === 'icon' ? 'fa fa-wifi' : 'ghostwhite')

        case 'Contractor':
          return (type === 'icon' ? 'fa fa-tools' : 'ivory')

        case 'Telco':
          return (type === 'icon' ? 'fa fa-users' : 'azure')

        case 'Tower Supplier':
          return (type === 'icon' ? 'fa fa-broadcast-tower' : 'LavenderBlush')

        case 'Tower Company':
          return (type === 'icon' ? 'fa fa-address-card' : 'aliceblue')

        default:
          return ''
      }

    },

    getCatColour (cat) {
      return this.getCatMetaData(cat, 'color')
    },


    getCatIcon (cat) {
      return this.getCatMetaData(cat, 'icon')
    },

    selectCategory (list, cat) {
      let org = list

      for (let i = 0; i < list.length; i++) {

        // TODO handle array
        if (cat && list[i].label.toLowerCase() === cat.toLowerCase()) {
          org = list[i].options
        }
      }

      return org
    },



    findObj (value) {
      let list = this.groups
      let obj = null

      for (let i = 0; i < list.length; i++) {

        if (list[i].options) {

          for (let i2 = 0; i2 < list[i].options.length; i2++) {
            if (list[i].options[i2].value === value) {
              obj = list[i].options[i2].data
            }
          }

        } else {

          if (list[i].value === value) {
            obj = list[i].data
          }
        }
      }

      return obj
    },


    updated (value) {
      let obj = this.findObj(value)

      this.$emit('input', this.fullObject ? obj : value)
      this.$emit('change', this.fullObject ? obj : value)
    }
  },

  data () {
    return {
      formData: this.value,
      groups: this.selectCategory(this.getConfig().orgGroups, this.type),
      el: this.noForm ? 'div' : 'el-form-item'
    }  // data
  }
}
</script>
